export enum Toast {
    SUCCESS, INFO, WARNING, DANGER
}